type SetZoomProps = {
  startZoom?: number;
  finalZoom: number;
  startTime?: number;
};

export const useSetZoom = (map?: google.maps.Map | null) => {
  function setZoom(props: SetZoomProps) {
    if (!map) return;
    requestAnimationFrame((time) => {
      const { startZoom = map.getZoom(), finalZoom, startTime = time } = props;
      if (!startZoom) return;
      const direction = startZoom > finalZoom ? "out" : "in";
      const elapsed = time - startTime;
      const modifier = (elapsed / 1000) * 6;
      const zoom =
        direction === "out"
          ? Math.max(startZoom - modifier, finalZoom)
          : Math.min(startZoom + modifier, finalZoom);
      map?.moveCamera({ zoom });
      if (
        (direction === "out" && zoom > finalZoom) ||
        (direction === "in" && zoom < finalZoom)
      ) {
        setZoom({ ...props, startZoom, startTime });
      }
    });
  }
  return setZoom;
};


type PanCameraProps = {
  endPosition: google.maps.LatLng;
  startPosition?: google.maps.LatLng;
  startTime?: number;
};

export const usePanCamera = (map: google.maps.Map | null) => {
  const panPercentPerSecond = 2;
  function panCamera(props: PanCameraProps) {
    if (!map) return;
    requestAnimationFrame((time) => {
      const {
        startPosition = map.getCenter(),
        endPosition,
        startTime = time,
      } = props;
      if (!startPosition) return;
      const elapsed = time - startTime;
      const percent = Math.min((elapsed / 1000) * panPercentPerSecond, 1);
      const center = {
        lat:
          startPosition.lat() +
          percent * (endPosition.lat() - startPosition.lat()),
        lng:
          startPosition.lng() +
          percent * (endPosition.lng() - startPosition.lng()),
      };
      map?.moveCamera({ center });
      if (percent < 1) panCamera({ ...props, startPosition, startTime });
    });
  }
  return panCamera;
};